import { createThunkActions } from '@utilities';

export const getConfig = createThunkActions('@app/GET_CONFIG');
export const setConfig = createThunkActions('@app/SET_CONFIG');
